import type { IUpdateStoreAddress, IUpdateStoreRequest } from '@/common/interfaces/store.interface';

export interface IStoreShippingAddressFormValues {
  shippingName?: string;
  attentionName?: string;
  street1?: string;
  street2?: string;
  city?: string;
  state?: { label?: string; value?: string };
  shippingZipCode?: string;
}

const toNullableAddressField = (value: string | undefined): string | null => {
  const trimmedValue = value?.trim() ?? '';

  return trimmedValue || null;
};

export const buildStoreShippingAddressPayload = (
  values: IStoreShippingAddressFormValues
): IUpdateStoreAddress => ({
  shipping_name: toNullableAddressField(values.shippingName),
  attention_name: toNullableAddressField(values.attentionName),
  street_1: toNullableAddressField(values.street1),
  street_2: toNullableAddressField(values.street2),
  city: toNullableAddressField(values.city),
  state: toNullableAddressField(values.state?.value),
  country: 'US',
  zip_code: toNullableAddressField(values.shippingZipCode),
});

export const buildStoreShippingAddressUpdatePayload = (
  orderId: number,
  values: IStoreShippingAddressFormValues
): IUpdateStoreRequest => ({
  order_id: orderId,
  address: buildStoreShippingAddressPayload(values),
});
